/**
 * Created by USER on 18/5/11.
 */
import i18n from 'i18next';
import Detector from 'i18next-browser-languagedetector';
import backend from 'i18next-xhr-backend';
import { reactI18nextModule } from "react-i18next";
import en from './enUS.json';
import zh from './zhCN.json';

i18n
  .use(Detector)
  .use(backend)
  .use(reactI18nextModule)
  .init({
    resources: {
      en: {
        translations: en
      },
      zh: {
        translations: zh
      }
    },

    // lng: "zh",
    fallbackLng: ['zh', 'en'],  // 如果用户语言不可用翻译，则使用该语言
    // debug: true, // 将信息弄到控制台

    // have a common namespace used around the full app
    ns: ['translations'],
    defaultNS: 'translations',

    keySeparator: false, // we use content as keys

    interpolation: {
      escapeValue: false, // 插值 not needed for react!!
      formatSeparator: ','
    },

    react: {
      wait: true
    }
  });

export default i18n;
